import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortByKey',
})
export class SortByKeyPipe implements PipeTransform {
  transform<T, U extends keyof T>(data: T[], key: U | string, sortUp: boolean): T[] {
    const keyArr = data.map(x => x[key as U]);

    // 判断是数字还是字符串，采取不同的排序函数
    if (typeof keyArr[0] === 'string') {
      (keyArr as string[]).sort((a, b) => a.localeCompare(b));
    } else {
      (keyArr as number[]).sort((a, b) => a - b);
    }

    // 是否反转
    if (!sortUp) keyArr.reverse();

    const result: T[] = [];
    keyArr.forEach(x => {
      const item = data.find(y => y[key as U] === x);
      item && result.push(item);
    });
    return result;
  }
}
